import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Chip, useTheme } from '@mui/material'
import React from 'react'
import { ratingButtonsInfo } from 'utils/constants'

function RatingButtonsGuide() {
    const mainTheme = useTheme()

  return (
    <>
    {ratingButtonsInfo.map((ratingBtn) => (
        <Chip
          key={ratingBtn.score}
          icon={
            <FontAwesomeIcon
              icon={ratingBtn.icon}
              size="2xl"
              style={{ color: "#fff" }}
            />
          }
          label={ratingBtn.value}
          sx={{
            color: mainTheme.palette.whitePrimary.main,
            border: `2px solid ${mainTheme.palette.whitePrimary.main}`,
            height: 44,
            fontSize: "1rem",
          }}
          variant="outlined"
          size="medium"
        />
      ))}
    </>
  )
}

export default RatingButtonsGuide